import React from "react";

const SendEmailIcon: React.FC<{
  width: number;
  height: number;
}> = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 239 228"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4297 98.5353C13.4297 94.8618 15.1934 91.4117 18.171 89.2605L112.87 20.8414C116.87 17.9515 122.272 17.9515 126.272 20.8414L220.971 89.2604C223.949 91.4117 225.713 94.8618 225.713 98.5353V136.6C225.713 142.919 220.59 148.042 214.27 148.042H24.872C18.5526 148.042 13.4297 142.919 13.4297 136.6V98.5353Z"
      fill="#2F465E"
    />
    <g filter="url(#filter0_d_1384_2626)">
      <rect
        x={58.1211}
        y={26.1572}
        width={122.901}
        height={117.822}
        rx={20.5961}
        fill="white"
      />
    </g>
    <g filter="url(#filter1_d_1384_2626)">
      <path
        d="M13.4297 96.2402L113.649 130.501C117.488 131.813 121.654 131.813 125.493 130.501L225.713 96.2402V191.692C225.713 201.803 217.516 210 207.405 210H31.7373C21.6263 210 13.4297 201.803 13.4297 191.692V96.2402Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter2_d_1384_2626)">
      <path
        d="M13.4297 102.614L113.649 136.875C117.488 138.187 121.654 138.187 125.493 136.875L225.713 102.614L225.714 191.692C225.714 201.803 217.517 209.999 207.406 209.999H31.7381C21.6272 209.999 13.4306 201.803 13.4305 191.692L13.4297 102.614Z"
        fill="#547190"
      />
    </g>
    <path
      d="M77.2274 189.095H28.3285C28.0282 189.096 27.7308 189.037 27.4533 188.922C27.1758 188.807 26.9236 188.638 26.7112 188.425C26.4987 188.212 26.3302 187.959 26.2152 187.681C26.1002 187.402 26.041 187.104 26.041 186.803C26.041 186.501 26.1002 186.203 26.2152 185.924C26.3302 185.646 26.4987 185.393 26.7112 185.18C26.9236 184.967 27.1758 184.798 27.4533 184.683C27.7308 184.568 28.0282 184.509 28.3285 184.51H77.2274C77.5277 184.509 77.8251 184.568 78.1026 184.683C78.3801 184.798 78.6323 184.967 78.8447 185.18C79.0572 185.393 79.2257 185.646 79.3407 185.924C79.4557 186.203 79.5149 186.501 79.5149 186.803C79.5149 187.104 79.4557 187.402 79.3407 187.681C79.2257 187.959 79.0572 188.212 78.8447 188.425C78.6323 188.638 78.3801 188.807 78.1026 188.922C77.8251 189.037 77.5277 189.096 77.2274 189.095V189.095Z"
      fill="#2F455D"
    />
    <path
      d="M45.8723 179.238H28.3285C28.0282 179.238 27.7308 179.179 27.4533 179.064C27.1758 178.949 26.9236 178.78 26.7112 178.567C26.4987 178.355 26.3302 178.102 26.2152 177.823C26.1002 177.545 26.041 177.247 26.041 176.945C26.041 176.644 26.1002 176.345 26.2152 176.067C26.3302 175.789 26.4987 175.536 26.7112 175.323C26.9236 175.11 27.1758 174.941 27.4533 174.826C27.7308 174.711 28.0282 174.652 28.3285 174.652H45.8723C46.1726 174.652 46.47 174.711 46.7475 174.826C47.025 174.941 47.2772 175.11 47.4896 175.323C47.7021 175.536 47.8706 175.789 47.9856 176.067C48.1006 176.345 48.1598 176.644 48.1598 176.945C48.1598 177.247 48.1006 177.545 47.9856 177.823C47.8706 178.102 47.7021 178.355 47.4896 178.567C47.2772 178.78 47.025 178.949 46.7475 179.064C46.47 179.179 46.1726 179.238 45.8723 179.238Z"
      fill="#2F455D"
    />
    <path
      d="M113.45 116.833C111.197 116.837 109.003 116.106 107.2 114.749L107.088 114.665L83.5486 96.5768C82.4585 95.7385 81.5435 94.6929 80.856 93.4997C80.1684 92.3065 79.7218 90.989 79.5416 89.6226C79.3614 88.2561 79.4511 86.8674 79.8056 85.5358C80.1601 84.2041 80.7725 82.9556 81.6078 81.8615C82.4431 80.7674 83.4849 79.8491 84.6738 79.159C85.8627 78.469 87.1753 78.0208 88.5368 77.8399C89.8983 77.659 91.2819 77.749 92.6088 78.1048C93.9356 78.4606 95.1796 79.0753 96.2697 79.9136L111.517 91.6473L147.548 44.4864C148.384 43.3926 149.426 42.4746 150.615 41.785C151.804 41.0954 153.117 40.6476 154.478 40.4672C155.84 40.2868 157.224 40.3774 158.55 40.7337C159.877 41.09 161.121 41.7051 162.21 42.5438L161.986 42.8491L162.216 42.5483C164.415 44.244 165.853 46.7458 166.216 49.5046C166.579 52.2635 165.837 55.0541 164.152 57.2643L121.771 112.737C120.79 114.015 119.53 115.05 118.087 115.76C116.644 116.47 115.058 116.838 113.45 116.833V116.833Z"
      fill="#399DEB"
    />
    <defs>
      <filter
        id="filter0_d_1384_2626"
        x={28.3711}
        y={0.984196}
        width={182.4}
        height={177.322}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4.57691} />
        <feGaussianBlur stdDeviation={14.875} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1384_2626"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1384_2626"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1384_2626"
        x={0.843172}
        y={88.2306}
        width={237.456}
        height={138.933}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4.57691} />
        <feGaussianBlur stdDeviation={6.29326} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1384_2626"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1384_2626"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_1384_2626"
        x={0.843172}
        y={94.6047}
        width={237.456}
        height={132.558}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4.57691} />
        <feGaussianBlur stdDeviation={6.29326} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1384_2626"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1384_2626"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SendEmailIcon;
